var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _vm._v(" "),
      _c("top-nav", {
        staticClass: "topmenu-container",
        attrs: { id: "topmenu-container" },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "我的站内信",
                      effect: "dark",
                      placement: "bottom",
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "right-menu-item hover-effect",
                        attrs: { to: "/message/my-message" },
                      },
                      [
                        _c(
                          "el-badge",
                          {
                            staticClass: "item",
                            attrs: {
                              hidden: _vm.index <= 0,
                              value: _vm.index,
                              max: 99,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-message",
                              staticStyle: {
                                color: "#ffffff",
                                "font-size": "18px",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "公告",
                      effect: "dark",
                      placement: "bottom",
                      id: "notice",
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "right-menu-item hover-effect",
                        attrs: { to: "/system/person-notice" },
                      },
                      [
                        _c(
                          "el-badge",
                          {
                            staticClass: "item",
                            attrs: {
                              "is-dot": _vm.dotIndex > 0 ? true : false,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-bell",
                              staticStyle: {
                                color: "#ffffff",
                                "font-size": "18px",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "清除缓存",
                      effect: "dark",
                      placement: "bottom",
                    },
                  },
                  [
                    _c("clear-cache", {
                      staticClass: "right-menu-item hover-effect",
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("img", {
                  staticClass: "user-avatar",
                  attrs: { src: _vm.avatar },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.name))]),
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-caret-bottom" }),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/user/profile" } },
                    [_c("el-dropdown-item", [_vm._v("个人中心")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [_c("span", [_vm._v("退出登录")])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }